module.exports = __webpack_public_path__ + "img/zircly_slack_icon.692fbe03.png";